// import { Map, List } from "immutable";
import { createListReducer } from "./base-reducers";
import LenderActions from "../constants/actions";

const listReducer = createListReducer(LenderActions.CREDIT_POLICY.LIST);

export default (state, action) => {
    return [
        listReducer
    ].reduce((state, reducer) => reducer(state, action), state);
};